import { DeviceTemplateData } from "./mapTemplateDataToDeviceInput";

interface ValidationParams {
  parsedTemplateData: DeviceTemplateData[] | null;
  selectedNodes: { nodeId: string; nodeIP: string; nodeName: string }[];
  devicePassword: string;
}

interface ValidationResult {
  isValid: boolean;
  errorMessage?: string;
}

export const validateCreateDevicesFromTemplate = ({
  parsedTemplateData,
  selectedNodes,
  devicePassword,
}: ValidationParams): ValidationResult => {
  if (!parsedTemplateData) {
    return { isValid: false, errorMessage: "No template selected" };
  }

  const hasUnselectedNode = selectedNodes.some(
    node => !node.nodeId || !node.nodeIP || !node.nodeName
  );

  if (hasUnselectedNode) {
    return { isValid: false, errorMessage: "Please assign nodes" };
  }

  // Password is optional per AC#3: "can be empty at any stage"

  return { isValid: true };
};
